import $ from 'jquery';
import 'slick-carousel';
import Modal from './modal';
import getLayout from './get-modal-layout';

const classNames = {
  MOBILE_PHONE_HIDDEN: `mobile-phone--hidden`
};

class ModalVideo extends Modal {
  constructor() {
    super();
    this.toggle = this.page.querySelectorAll(`.screen__video, .js-modal-video`);
    // this.phone = this.page.querySelector(`.mobile-phone`);
  }

  init(locale) {
    this.locale = locale;
    super.createModal();
    this.createWrap();
    this.bindHandlers();
    this.onClose();
  }

  createWrap() {
    super.addLayout(getLayout(`modal-video-wrap`));
  }

  toggleModal = (isModalShown) => {
    super._toggleModal(isModalShown);
    this.phone.classList.toggle(classNames.MOBILE_PHONE_HIDDEN, isModalShown);
  };

  bindHandlers() {
    this.toggle.forEach((item) => {
      item.addEventListener(`click`, (e) => {
        e.preventDefault();
        this.page.classList.add('page--opened-modal-video');
        $('.modal__video.modal-video').closest('.modal').addClass('video-modal');
        $('.flats-types__toggles--footer').css('opacity', '0');
        // $('.modal-video iframe').attr('src', youtubeSrc);

        this._toggleModal(true);
      });
    })
  };

  onClose() {
    this.page.classList.remove('page--opened-modal-video');
    $('.modal-video iframe').attr('src', '');
    $('.flats-types__toggles--footer').css('opacity', '1')
  }
}

const modalVideo = new ModalVideo();

export default modalVideo;
